<template>
  <div :class="{'col-lg-6':isStageType, 'col-lg-4':isOtherType}"
       class="col-sm-6 item list2-item"
  >
    <a target="_blank" :href="linkVisor">
      <div class="item-content">
        <div class="title">{{ title }}</div>
        <img :src="linkImage" alt="">
        <div class="item-overlay" style="padding: 25px;">
          <h6 style="width: 100%" class="three-line-text">{{ descripcion ? descripcion : title }}</h6>
          <div class="icons">
                <span class="icon link">
                      <i class="fa fa-map"></i>
                </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
    import {AppConfig} from "../../../appConfig";

    export default {
        name: 'MapItem',
        props: {
            map: {
                type: Object,
                required: true
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
            title() {
                return this.map[`title_${this.locale}`];
            },
            descripcion() {
                return this.map[`description_${this.locale}`];
            },
            isStageType() {
                return this.map.category === 'ESCENARIOS'
            },
            isOtherType() {
                return this.map.category === 'OTROS'
            },
            linkVisor() {
                return `${AppConfig.APP_URL}/visor#/mapa/${this.map.code}`;
            },
            linkImage() {
                return `/storage/capturas_mapas/${this.map.code}.png`;
            }
        },
        methods: {}
    }
</script>
<style>
  .three-line-text {
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 16px; /* fallback */
    max-height: calc(16px * 3); /* fallback */
  }
</style>